import moment from 'moment';
import * as R from 'ramda';
import angular from 'angular';


export default function EditAgendaDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  loaderService,
  ssDialogService,
  oversightDataService,
) {
  const vm = this;

  if (!R.isNil(this.agenda.startDate)) {
    vm.startDate = moment(this.agenda.startDate);
  }
  if (!R.isNil(this.agenda.endDate)) {
    vm.endDate = moment(this.agenda.endDate);
  }
  if (!R.isNil(this.agenda.defaultDueDate)) {
    vm.defaultDueDate = moment(this.agenda.defaultDueDate);
  }

  vm.isActive = false;

  if (this.agenda.isActive !== null) {
    vm.isActive = this.agenda.isActive;
  }

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleAddAgendaFormSubmit = handleAddAgendaFormSubmit;
  vm.handleExpandSection = handleExpandSection;
  vm.isValidControl = isValidControl;

  _initEventListeners();

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleAddAgendaFormSubmit() {
    console.log(`handleAddAgendaFormSubmit: scope.valid: ${$scope.editAgendaForm.$valid}`);
    if ($scope.editAgendaForm.$valid) {
      loaderService.showViewLoader = true;
      _saveAgenda().then(() => {
        loaderService.showViewLoader = false;
      });
    }
  }

  function handleExpandSection($event, section) {
    vm[`${section}IsExpanded`] = !vm[`${section}IsExpanded`];
  }

  function isValidControl(ctrl) {
    return ($scope.editAgendaForm)
      && (($scope.editAgendaForm.$submitted && ctrl.$invalid) || (ctrl.$dirty && ctrl.$invalid));
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    loaderService.showViewLoader = false;
    if (vm.refreshAgenda && vm.agenda.agendaId > 0) {
      // Get this audit's coordinatorName from vm.coordinators
      angular.forEach(vm.coordinators, (item) => {
        if (item.userId === vm.agenda.coordinatorUserId) {
          vm.coordinatorName = item.fullName;
        }
      });
    }
  }
  function _initEventListeners() {
    $scope.$on('closeEditAgenda', () => { _closeDialog(); });
  }

  function _saveAgenda() {
    const dfdSave = $q.defer();
    const dfdHideDialog = $q.defer();

    if (_isValid()) {
      if (vm.isActive) {
        // Editing an active audit

        // Set the dates on audit object
        if (!R.isNil(vm.startDate)) {
          vm.agenda.startDate = moment(vm.startDate).format('MM/DD/YYYY');
        } else {
          vm.agenda.startDate = null;
        }

        if (!R.isNil(vm.endDate)) {
          vm.agenda.endDate = moment(vm.endDate).format('MM/DD/YYYY');
        } else {
          vm.agenda.endDate = null;
        }

        if (!R.isNil(vm.defaultDueDate)) {
          vm.agenda.defaultDueDate = moment(vm.defaultDueDate).format('MM/DD/YYYY');
        } else {
          vm.agenda.defaultDueDate = null;
        }

        // if (vm.agenda.isActive) {
        // We're just saving the agenda, (not completing it)
        // Update the agenda information
        oversightDataService.saveAgenda(vm.agenda).then((savedAgendaResponse) => {
          const savedAgenda = savedAgendaResponse.data;
          if (savedAgenda.agendaId === 'undefined' || savedAgenda.agendaId <= 0) {
            // There was an error saving the agenda information
            alerts.error('Error occurred while saving the Agenda.');
            dfdSave.reject();
          } else {
            // The agenda information has been saved
            vm.agenda.agendaId = savedAgenda.agendaId;
            alerts.success('The Agenda has been saved successfully.');
            $rootScope.$broadcast('refreshAgendas');
            ssDialogService.hide(ssDialogService.dialogs.oversight.editAgendaDialog)
              .then(dfdHideDialog.resolve);
          }
        });
      }
      dfdHideDialog.promise.then(dfdSave.resolve);
    } else {
      dfdSave.reject();
    }
    return dfdSave.promise;
  }

  // Expand/Collapse

  function _isValid() {
    let isValid = $scope.editAgendaForm.$valid;

    if (!isValid) {
      isValid = true;
      angular.forEach($scope.editAgendaForm.$error.parse, (item) => {
        if ((item.$name === 'editAgendaStartDate') || (item.$name === 'editAgendaDueDate')
        ) {
          if ((item.$modelValue !== null) && (!moment(item.$modelValue).isValid())) {
            isValid = false;
          }
        } else {
          isValid = false;
        }
      });
      angular.forEach($scope.editAgendaForm.$error.pattern, () => {
        isValid = false;
      });
      angular.forEach($scope.editAgendaForm.$error.required, () => {
        isValid = false;
      });
    }
    return isValid;
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.oversight.editAgendaDialog);
  }
}

EditAgendaDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'loaderService',
  'ssDialogService',
  'oversightDataService'
];
